import React from "react";
import { LabelData } from "./label_Interface";
import { Box, Typography } from "@mui/material";
import M3Tooltip from "../common/M3Tooltip";
import { Label } from "./Label";

interface LabelsProps {
  labels: LabelData[];
  inCard?: boolean;
  labelCompleteMode: boolean;
}

const Labels: React.FC<LabelsProps> = ({ labelCompleteMode, labels, inCard = false }) => {

  const limitNeeded = labels.length >= 2 && inCard;
  const visibleLabelsCount = limitNeeded ? 2 : labels.length;
  const remainingsLabelsCount = labels.length - visibleLabelsCount;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      flexWrap={inCard ? "nowrap" : "wrap"}
      rowGap={1}
    >
      {labels.slice(0, visibleLabelsCount).map((tag) => (
        <Label labelCompleteMode={labelCompleteMode} key={`label-${tag.id}`} name={tag.name} color={tag.css} />
      ))}
      {remainingsLabelsCount > 0 && (
        <M3Tooltip
          title={
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
              {labels.slice(visibleLabelsCount).map((tag) => (
                <Typography
                  key={`tooltip-tag-${tag.id}`}
                  component="div"
                  variant="caption"
                  sx={{ lineHeight: 1.4 }}
                >
                  {tag.name}
                </Typography>
              ))}
            </Box>
          }
        >
          <Typography>+{remainingsLabelsCount}</Typography>
        </M3Tooltip>
      )}
    </Box>
  );
};

export default Labels;
